<template>
  <div class="page-wrapper evaluate-page-wrapper">
    <van-nav-bar
    title="订单评价"
    left-text="返回"
    left-arrow
    @click-left="onClickLeft"
    />
    <van-cell-group>
    <van-cell title="尊敬的客户：" label="首先感谢您对国检集团（CTC）的信赖与支持！为了我们的共同利益，不断提高我们的服务水平，更好地服务客
                    户，我们需要了解您对我们工作的评价意见。谢谢！" />
    </van-cell-group>
    <van-form :label-width="130" @submit="handleOrderCommentConfirm">
        <van-field name="rate" label="总体印象">
            <template #input>
                <van-rate
                    v-model="evaluateForm.impression"
                    :size="25"
                    color="#ffd21e"
                    void-icon="star"
                    void-color="#eee"
                    :readonly="evaluateDisable"
                    />
            </template>
        </van-field>
        <van-field name="rate" label="服务质量">
            <template #input>
                <van-rate
                    v-model="evaluateForm.service"
                    :size="25"
                    color="#ffd21e"
                    void-icon="star"
                    void-color="#eee"
                    :readonly="evaluateDisable"
                    />
            </template>
        </van-field>
        <van-field name="rate" label="检验报告">
            <template #input>
                <van-rate
                    v-model="evaluateForm.report"
                    :size="25"
                    color="#ffd21e"
                    void-icon="star"
                    void-color="#eee"
                    :readonly="evaluateDisable"
                    />
            </template>
        </van-field>
        <van-field name="rate" label="技术咨询人员满意度">
            <template #input>
                <van-rate
                    v-model="evaluateForm.technical"
                    :size="25"
                    color="#ffd21e"
                    void-icon="star"
                    void-color="#eee"
                    :readonly="evaluateDisable"
                    />
            </template>
        </van-field>
        <van-field name="rate" label="受理时效">
            <template #input>
                <van-rate
                    v-model="evaluateForm.acceptAging"
                    :size="25"
                    color="#ffd21e"
                    void-icon="star"
                    :readonly="evaluateDisable"
                    void-color="#eee"
                    />
            </template>
        </van-field>
        <van-field name="rate" label="检验进度">
            <template #input>
                <van-rate
                    v-model="evaluateForm.inspectionShedule"
                    :size="25"
                    color="#ffd21e"
                    :readonly="evaluateDisable"
                    void-icon="star"
                    void-color="#eee"
                    />
            </template>
        </van-field>
        <van-field
            v-model="evaluateForm.otherAdvice"
            rows="3"
            autosize
            label="其他意见和建议"
            type="textarea"
            maxlength="200"
            placeholder="请填写其他意见和建议"
            show-word-limit
            :disabled="evaluateDisable"
        />

      <div style="margin: 16px;">
        <van-button :disabled="evaluateDisable" round block type="info" native-type="submit">
          {{evaluateDisable ? '感谢您的评价': '确认评价'}}
        </van-button>
      </div>
    </van-form>

  </div>
</template>

<script>
import { Toast } from 'vant';
export default {
    created(){
       const params = this.$route.params
       this.folder = params.item
       this.getEvaluationByFoldersId()
    },
    mounted(){
    },
    data(){
        return{
            folder: null,
            rate: 5,
            message: '',
            evaluateDisable: true,
            evaluateForm: {
                id: '',
                foldersId: '',
                cssAccountId: '',
                impression: 5,
                service: 5,
                report: 5,
                technical: 5,
                acceptAging: 5,
                inspectionShedule: 5,
                otherAdvice: '',
            },
        }
    },
    methods:{
        onClickLeft(){
            this.$router.go(-1)
        },
        getEvaluationByFoldersId() {
            const _this = this
            if(this.folder){
            _this.$get('/folder/getEvaluationByFoldersId/' + _this.folder.id).then(res => {
                        if (res.data.success) {
                            _this.evaluateForm = res.data.data
                            _this.evaluateDisable = true
                        } else {
                            _this.evaluateDisable = false
                            _this.evaluateForm = {
                                id: '',
                                foldersId: '',
                                cssAccountId: '',
                                impression: 5,
                                service: 5,
                                report: 5,
                                technical: 5,
                                acceptAging: 5,
                                inspectionShedule: 5,
                                otherAdvice: '',
                            }
                        }
                    })
            }else{
                Toast.fail({
                    position: 'bottom',
                    message: '获取订单信息失败'
                })
            }
     
        },
        handleOrderCommentConfirm() {
            const _this = this
            _this.evaluateForm.foldersId = _this.folder.id
            if(_this.evaluateDisable){
                Toast.fail({
                        position: 'bottom',
                        message: '您已评价该订单'
                })
            }
            _this.$post('/folder/evaluation', {..._this.evaluateForm})
                .then(res => {
                    Toast.success({
                            position: 'bottom',
                            message: '感谢您的评价，我们将继续竭诚为您服务'
                    })
                    _this.evaluateDisable = true
                })
        }
    }
}
</script>

<style>

</style>